import cx from 'classnames'
import React from 'react'
import * as track from '../../track/track'
import styles from './NavItemDropdown.module.scss'

interface NavLink {
  name: string
  divider?: boolean
  href?: string
  onClick?: () => void
  openNewTab?: boolean
}

interface NavItemDropdownProps {
  isExpanded: boolean
  items: NavLink[]
}

export const NavItemDropdown: React.FC<NavItemDropdownProps> = ({isExpanded, items}) => {
  return (
    <nav className={cx(styles.root, isExpanded && styles.rootOpen)}>
      <ul className={styles.list} role="menu">
        {items.map((subItem) => (
          <li
            key={subItem.name}
            className={cx({[styles.itemContainer]: subItem.divider})}
            role="menuitem"
          >
            {subItem.onClick ? (
              <button onClick={subItem.onClick} className={styles.item}>
                {subItem.name}
              </button>
            ) : (
              <a
                href={subItem.href}
                className={styles.item}
                target={subItem.openNewTab ? '_blank' : '_self'}
                rel="noreferrer"
                onClick={() => {
                  track.headerNavClicked(subItem.name, subItem.href)
                }}
              >
                {subItem.name}
              </a>
            )}
          </li>
        ))}
      </ul>
    </nav>
  )
}
